import {
  TooltipContent,
  TooltipContentColorMode,
  TooltipSkeleton,
  TooltipTrigger,
} from './shadcn-blocks/TooltipSkeleton';
import { isValidElement, PropsWithChildren, ReactNode, useMemo } from 'react';

interface Props extends PropsWithChildren {
  tip: ReactNode | undefined;
  colorMode?: TooltipContentColorMode;
  className?: string;
}

export function Tooltip({ tip, colorMode, className, children }: Props) {
  if (!tip) {
    return children;
  }

  const isChildrenButton = useMemo(
    () =>
      isValidElement(children)
        ? children?.type?.toString().toLowerCase().includes('button')
        : false,
    [children],
  );

  return (
    <TooltipSkeleton>
      <TooltipTrigger asChild={isChildrenButton}>
        {isChildrenButton ? <span className="inline-block">{children}</span> : children}
      </TooltipTrigger>
      <TooltipContent colorMode={colorMode} className={className}>
        {tip}
      </TooltipContent>
    </TooltipSkeleton>
  );
}
